module.exports = __webpack_public_path__ + "media/images/pic/hero/mobile-5feb2a25c647bd1e957dde1d28dcb6fb.jpg";